/*
 *		Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Session')
    .directive('accCloudPlatformChineseRegistrationInfo', [
        'CloudPlatformPresentation',
        function (CloudPlatformPresentation) {
            return {
                scope: {
                    hideTitle: '=',
                    wrapLines: '='
                },
                template: '<footer ng-if="links.length > 0" class="chinese-registration-info">\
                            <p ng-hide="hideTitle" class="chinese-registration-info__title">{{ "cloud_platform_chinese_registration_information_note" | translate }}</p>\
                            <p ng-class="{\'chinese-registration-info__items--wrap-lines\': wrapLines}" class="chinese-registration-info__items">\
                                <a class="chinese-registration-info__link" target="_blank" rel="noopener" ng-href="{{links[0].link}}">{{links[0].text}}</a>\
                                <a class="chinese-registration-info__link" target="_blank" rel="noopener" ng-href="{{links[1].link}}">{{links[1].text}}</a>\
                            </p>\
                        </footer>',
                link: function ($scope) {
                    $scope.links = [];

                    CloudPlatformPresentation.getPresentationLinks()
                        .then(function (links) {
                            $scope.links = links;
                        });
                }
            }
        }
    ]);
